<form [formGroup]="courseAllocationForm" (ngSubmit)="saveEmployeeCourseAllocation(inProgress)">
    <div class=" modal-header">
      <h5 class="modal-title d-flex align-items-center">
        <i class="ri-user-follow-line me-1 font-20 text-primary"></i>{{courseAllocationForm?.value.id?'Update':'Add'}}  Course Allocation -{{context?.employeeName || courseAllocation.employeeName}}
      </h5>
      <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close"
        (click)="activeModal.close('Close')"></button>
    </div>
    <div class="modal-body">
      <div class="row g-3 justify-content-center">
        <div class="col-md-6">
            <label for="courseId" class="form-label">Course<b class="text-secondary">*</b></label>
            <div class="input-group">
              <span class="input-group-text bg-transparent border-end-0"><i class='bx bxs-layer'></i></span>
              <ng-select  class="form-control rcx-ng-select" formControlName="courseId" placeholder="Select Course"
                [ngClass]="{'is-invalid': submitted && c.courseId.errors}"  (change)="fetchTimezoneByCourse($event)"
                >
                <ng-option *ngFor=" let type of courses;" [value]="type.id">{{type.name}}</ng-option>
              </ng-select>
              <div class="invalid-feedback" *ngIf="submitted && c.courseId.errors">
                <span *ngIf="a.courseId.errors.required">Please select a course .</span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <label for="courseTestId" class="form-label">CourseTest Name <b class="text-secondary">*</b></label>
            <div class="input-group">
              <span class="input-group-text bg-transparent border-end-0"><i class='bx bxs-layer'></i></span>
              <ng-select  class="form-control rcx-ng-select" formControlName="courseTestId" placeholder="Select CourseTestName"
                [ngClass]="{'is-invalid': submitted && c.courseTestId.errors}">
                <ng-option *ngFor=" let type of courseTests;" [value]="type.id">{{type.name}}</ng-option>
              </ng-select>
              <div class="invalid-feedback" *ngIf="submitted && c.courseTestId.errors">
                <span *ngIf="c.courseTestId.errors.required">Please select a courseTestName .</span>
              </div>
            </div>
          </div>
        <div class="col-md-4">
          <label for="date" class="form-label">Start Date<b class="text-secondary">*</b></label>
          <div class="input-group"> <span class="input-group-text bg-transparent  border-end-0"><i
                class='bx bx-calendar'></i></span>
            <input type="date" class="form-control ps-1" id="startDate" formControlName="startDate"
              [ngClass]="{'is-invalid': submitted && c.startDate.errors}" />
            <div class="invalid-feedback" *ngIf="submitted && c.startDate.errors">
              <span *ngIf="c.startDate.errors.required">Please provide a valid date.</span>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <label for="date" class="form-label">To Date<b class="text-secondary">*</b></label>
          <div class="input-group">
            <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-calendar'></i></span>
            <input type="date" class="form-control ps-1" id="endDate" formControlName="endDate"
              [min]="courseAllocationForm.value?.startDate" [ngClass]="{'is-invalid': submitted && c.endDate.errors}"
              [disabled]="!courseAllocationForm.value.startDate" />
            <div class="invalid-feedback" *ngIf="submitted && c.endDate.errors">
              <span *ngIf="a.endDate.errors.required">Please provide a valid date.</span>
            </div>
          </div>
        </div>
        <div class="col-md-4">
            <div class="form-check">
                <input class="form-check-input" type="checkbox" id="disabled" formControlName="disabled">
                <label class="form-check-label" for="prime">Disabled</label>
            </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="activeModal.close('Close')"><i
          class="bx bx-x"></i>Close</button>
      <button type="submit" class="btn btn-secondary" #inProgress [ngClass]="{'no-event':inProgress?.value=='true'}">
        <ng-container *ngIf="inProgress?.value=='true'">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{courseAllocationForm.value.id?'Updating...':'Saving...'}}
        </ng-container>
        <ng-container *ngIf="inProgress?.value!='true'">
          <i class="bx bx-save"></i>{{courseAllocationForm?.value.id?'Save Changes':'Save'}}
        </ng-container>
      </button>
    </div>
  </form>
  